import React, { createRef } from "react";
import { withRouter, Route, Switch } from "react-router-dom";
import { vcMessenger } from "react-lib/compat/vc-websocket";
// CSS
import { InputProps } from "semantic-ui-react";

// Library
import Cookies from "js-cookie";
import Fingerprint2 from "fingerprintjs2";
import SlideRoutes from "react-slide-routes";
import {
  IntlProvider,
  FormattedMessage,
  createIntlCache,
  createIntl,
} from "react-intl";
import * as serviceWorker from "../serviceWorker";

// IsHealth
import {
  askUserPermission,
  createNotificationSubscription,
} from "react-lib/apps/IsHealth/Common/push-notifications";
import { flattenMessages } from "react-lib/localization/IsHealth/util";
import messages from "react-lib/localization/IsHealth/messages";

// Framwords
import SetProp from "react-lib/frameworks/SetProp";

// Controller
import MobTransformController from "./MobTransformController";

// Interface
import * as MobTransformI from "./MobTransformInterface";

// UI
import TFLogin from "react-lib/apps/IsHealth/Transform/TFLogin";
import TFRegister from "react-lib/apps/IsHealth/Transform/TFRegister";
import TFSignInEmail from "react-lib/apps/IsHealth/Transform/TFSignInEmail";
import TFVerifyIdentity from "react-lib/apps/IsHealth/Transform/TFVerifyIdentity";
import TFForgetPassword from "react-lib/apps/IsHealth/Transform/TFForgetPassword";
import TFBottomNavigation from "react-lib/apps/IsHealth/Transform/TFBottomNavigation";
import TFChatList from "react-lib/apps/IsHealth/Transform/TFChatList";
import TFHead from "react-lib/apps/IsHealth/Transform/TFHead";

import { ChatList } from "./Chat";
import ChatBox from "react-lib/apps/IsHealth/Chat/ChatBox";
import { DiagRule, DiagRuleSearch } from "./DiagRule";
import DiagForm from "./DiagForm";
import OfficialAccount from "./OfficialAccount";
import ProfileWrap from "./ProfileWrap";
import Profile from "./Profile";
import PatientSelectAppointment from "react-lib/apps/QUE/PatientSelectAppointment";
import TimePatient from "react-lib/apps/QUE/TimePatient";
import PatientPayment from "./PatientPayment";
import PatientPaymentDetail from "./PatientPaymentDetail";
import EditAddress from "../Address/EditAddress";
import SelectAddress from "../Address/SelectAddress";
import DrugAddressConfirm from "../Address/DrugAddressConfirm";

import ModConfirm from "react-lib/apps/common/ModConfirm";
import { SettingPopup } from "./MainPatient";

import CONFIG from "../config/config";

// Style
import "react-lib/apps/IsHealth/Transform/Transform.scss";
import config from "../config/config";
import { useIntl } from "react-intl";
import MessageContentHTML, { handleSetupMessageHtml } from "react-lib/apps/IsHealth/Chat/MessageContentHTML";
import ButtonPayment from "react-lib/apps/IsHealth/Common/ButtonPayment";
import { signOut } from "firebase/auth";

declare global {
  var iosNative: any;
  var MobNative: any;
  var FB: any;
}

const THEME = {
  DEFAULT: "",
  PENTA: "penta",
  TU: "tu",
  PENGUIN: "penguin",
};

const URL_PREFIX = {
  PENGUIN: "penguin",
};

const PROJECT_NAME = {
  M_B_PLUS_TELEMED: "My B+ Telemed",
  TU: "TU",
};

const LANGUAGE: {
  TH: "th-TH";
  EN_US: "en-US";
} = {
  TH: "th-TH",
  EN_US: "en-US",
};

const TUH_TRANSFORM = "/tuh-transform";

class MobTransform extends React.Component<any, MobTransformI.State> {
  controller: MobTransformController;
  chatListRef: any;
  chatBoxRef: any;
  lastReadMessage: any;
  selectAddressRef: any;
  drugAddressConfirmRef: any;
  currentPathname: any;
  unlisten: any;

  constructor(props: any) {
    super(props);
    this.state = {
      ...MobTransformI.StateInitial,
    };
    this.controller = new MobTransformController(
      () => {
        return this.state;
      },
      (state: MobTransformI.State, callback: any) => {
        this.setState(state, callback);
      },
      window
    );
    this.controller.setProp = SetProp(this, "");
    this.controller.cookies = Cookies;

    // Ref
    this.chatListRef = createRef();
    this.chatBoxRef = React.createRef();
    this.currentPathname = createRef();
    this.selectAddressRef = createRef();
    this.drugAddressConfirmRef = createRef();
    this.lastReadMessage = null;

    vcMessenger.onMessage((message: any) => {
      console.log({ message });
      if (message["data_message_type"] === "MESSAGE") {
        if (this.chatListRef) {
          this.loadChannelList();
        }
        if (this.chatBoxRef && this.chatBoxRef.receivedMessage) {
          this.chatBoxRef.receivedMessage({
            chatChannelId: parseInt(message["channel_id"]),
          });
        }
      } else if (message["data_message_type"] === "MESSAGE_READ") {
        if (this.lastReadMessage === message.message_id) {
          return;
        }
        this.lastReadMessage = message.message_id;
        if (this.chatBoxRef && this.chatBoxRef.receivedMessageRead) {
          this.chatBoxRef.receivedMessageRead({
            chatChannelId: parseInt(message["channel_id"]),
            messageId: parseInt(message["message_id"]),
          });
        }
      } else if (message["event"] === "RECLASSIFY") {
        if (this.chatBoxRef && this.chatBoxRef.loadPatientEncounter) {
          this.chatBoxRef.loadPatientEncounter();
        }
      }
    });
  }

  componentDidMount = () => {
    this.controller.handleEvent({ message: "DidMount", params: {} });
    let currentURL = window.location.href;
    if (CONFIG.COMPANY === "BDMS") {
      this.setState({
        theme: THEME.PENGUIN,
        projectName: PROJECT_NAME.M_B_PLUS_TELEMED,
      });
      document.documentElement.setAttribute("data-theme", THEME.PENGUIN);
      Cookies.set("theme", THEME.PENGUIN, { path: "/" });
      Cookies.set("project_name", PROJECT_NAME.M_B_PLUS_TELEMED, {
        path: "/",
      });
    } else if (CONFIG.COMPANY === "TU") {
      document.documentElement.setAttribute("data-theme", THEME.TU);
      Cookies.set("theme", THEME.TU, { path: "/" });
      Cookies.set("project_name", PROJECT_NAME.TU, {
        path: "/",
      });
    } else {
      this.setState({ theme: THEME.PENTA });
      document.documentElement.setAttribute("data-theme", THEME.PENTA);
      Cookies.set("theme", THEME.PENTA, { path: "/" });
    }

    const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
    if (prefersDarkScheme.matches) {
      // set dark-theme
      document.documentElement.setAttribute("color-scheme", "dark");
    } else {
      // remove dark-theme
      document.documentElement.setAttribute("color-scheme", "light");
    }

    document.querySelector("body")?.classList.add("body-tf-transform");

    // Get apiToken and userId from mobNative
    if (window.MobNative) {
      requestIdleCallback(() => {
        console.log("get fingerprint on requestIdleCallback");
        this.getFingerPrint();
        this.getApiToken(this.props);
      });
    } else {
      console.log("fallback with timeout");
      setTimeout(() => {
        this.getFingerPrint();
        this.getApiToken(this.props);
      }, 500);
    }
  };

  componentWillMount() {
    this.currentPathname.current = this.props.history.location.pathname;
    this.unlisten = this.props.history.listen(
      (location: any, action: string) => {
        if (config.LOGIN_WITH_TUH_TRANSFORM) {
          if (!location.pathname.includes(TUH_TRANSFORM)) {
            this.props.history.replace({
              pathname:
                `${TUH_TRANSFORM}${location.pathname}` + location.search,
              state: location.state,
            });
          } else if (action === "REPLACE") {
            return;
          }
        }

        this.controller.handleEvent({
          message: "HandleRouteChange",
          params: {
            currentPathname: this.currentPathname.current,
            nextPathname: location.pathname,
            action,
          },
        });
        this.currentPathname.current = location.pathname;
      }
    );

    // Options for the observer (which mutations to observe)
  }
  componentWillUnmount() {
    this.unlisten();
  }

  getFingerPrint = () => {
    var options = {};
    Fingerprint2.getPromise(options).then((components: any) => {
      // components is array of {key: 'foo', value: 'component value'}
      var values = components.map(function (component: any) {
        return component.value;
      });
      var device_id = Fingerprint2.x64hash128(values.join(""), 31);
      this.setState({ device_id: device_id });
      console.log("MP Fingerprint id:", device_id);
      // Get subscription endpoint object
      createNotificationSubscription()
        .then((subscription) => {
          this.setState({ subscription: subscription });

          console.log("MP Success get notification subscription..");
          console.log(subscription);
        })
        .catch((err) => {
          console.log("MP error getSubScriptionObejct");
          console.error(
            "Couldn't create the notification subscription",
            err,
            "name:",
            err.name,
            "message:",
            err.message,
            "code:",
            err.code
          );
        });
    });
  };

  getApiToken = async (props: any) => {
    console.log(" getApiToken called");
    var apiToken;
    var userId;

    console.log("get apiToken from browser (cookies)");
    if (props) {
      apiToken = Cookies.get("apiToken");
      userId = Cookies.get("userId");

      this.setState({ apiToken: apiToken, userId: userId });
      this.controller.handleEvent({
        message: "GetPatientDetail",
        params: {},
      });
      this.setWebsocket({ apiToken: apiToken });

      console.log(" apiToken", apiToken);
      console.log(" userId", userId);
    }
  };

  setWebsocket = ({ apiToken }: any = {}) => {
    console.log("setWebsocket");
    console.log(apiToken, "apiToken");
    console.log(CONFIG.WS_HOST, "CONFIG.WS_HOST");
    vcMessenger.connect(
      "MSG",
      {
        token: apiToken,
      },
      CONFIG.WS_HOST
    );
  };

  handleChatChannelSelected = (path: string) => {
    this.setState({ disabledScrollIntoView: true });
    this.props.history.push({
      pathname: `${path}`,
      state: {},
    });

    setTimeout(() => {
      this.setState({ disabledScrollIntoView: false });
    }, 350);
  };

  handleRedirectChatChannelSelected = (path: string) => {
    window.location.assign(path);
  };

  handleChatSearchChange = async (e: any, v: InputProps) => {
    this.setState({ chatSearchValue: v.value });
  };

  handleUnfollowChannelSelected = (item: any) => {
    // 1 = dm,
    // 2 = mom and child

    let channel = item === 1 ? "DM" : "MOM";
    // alert("Waiting API Follow " + channel )
    if (item === 1) {
      window.location.assign(CONFIG.DM_BPLUS_URL);
    } else if (item === 2) {
      window.location.assign(CONFIG.MOM_BPLUS_URL);
    }
  };

  handleSetChatName = ({
    name,
    division,
  }: { name?: string; division?: number } = {}) => {
    this.setState({ chatName: name, chatDivision: division });
  };

  handleNavigationMessage = ({
    content = "",
    contentPayload = "",
    contentType,
    channelId,
  }: any = {}) => {
    if (content.includes("หน้าโปรไฟล์") || contentPayload.target === "profile") {
      return (
        <>
        {handleSetupMessageHtml(content,"profile")}
        </>
      );
    } else if (content.includes("{ตารางออกตรวจผู้ให้คำปรึกษา}") || contentPayload.target === "appointment") {
      return (
        <>
        {handleSetupMessageHtml(content,"Appointment")}
        </>
      );
    } else if (
      (content.includes("{ชำระเงิน}") || contentPayload.target === "payment") &&
      CONFIG.ENABLE_SMART_PAYMENT
    ) {
      return (
        <>
          {handleSetupMessageHtml(content.replace(/{ชำระเงิน}/g, ""),undefined)}
          <ButtonPayment
            title={<FormattedMessage id="bplusClinicKey1148"/>}
            // callback
            onClick={() =>
              (window.location.href = `/waiting-payment/telemed/?app=MobPayment&channelid=${channelId}`)
            }
          />
        </>
      );
    } else if (
      (content.includes("{กดเพื่อยืนยันการจัดส่งยา}") || contentPayload.target === "drug_address") &&
      CONFIG.ENABLE_SMART_PAYMENT
    ) {

      return (
        <>
          {handleSetupMessageHtml(content.replace(/{กดเพื่อยืนยันการจัดส่งยา}/g, ""),undefined)}
          <ButtonPayment
            title={useIntl().formatMessage({id: "bplusClinicKey1352"})}
            // callback
            onClick={() =>
              (window.location.href = `/payment/${"telemed"}/?app=MobPayment&channelid=${channelId}`)
            }
          />
        </>
      );
    } else if (content.includes("{กดเพื่อยืนยันการจัดส่งยา}") || contentPayload.target === "drug_address") {
      return (
        <div
          aria-hidden="true"
          onClick={() => 
            this.props.history.push({
              pathname: `/drug-address-confirm/${contentPayload.encounter}/`,
              channelId,
            })
          }
        >
          <MessageContentHTML content={content.replace(/{กดเพื่อยืนยันการจัดส่งยา}/g,
          `<a nohref>${useIntl().formatMessage({id: "bplusClinicKey1352"})}</a>`)}/>
          </div>
      );
    } else if (content.includes("{ดูประวัติการนัดหมาย}") || contentPayload.target === "appointment") {
      return (
        <div
          onClick={() =>
            this.props.history.push({
              pathname: "/VCAppointmentView",
              state: {
                channelId,
              },
            })
          }

        >
        <MessageContentHTML content={content.replace(/{ดูประวัติการนัดหมาย}/g,
        `<a nohref>${useIntl().formatMessage({id: "ดูประวัติการนัดหมาย"})}</a>`)}/>
        </div>
      );
    } else if (contentType === "bill") {
      let routePath = `/payment`;
      if (contentPayload.invoice_id) {
        routePath = `/paymentDetail/${contentPayload.invoice_id}`;
      }
      return (
        <div
          onClick={() =>
            this.props.history.push({
              pathname: routePath,
            })
          }
        >
          <a
            // @ts-ignore
            nohref
          >
            {handleSetupMessageHtml(content,null)}
          </a>
        </div>
      );
    } else {
      return handleSetupMessageHtml(content,null);
    }
  };

  handleAddDiagRule = () => {
    this.props.history.push({
      pathname: `/diagrulesearch`,
      state: {},
    });
  };

  handleGoToLogin = () => {
    console.log(" handleGoToLogin /Login");
    this.props.history.push(
      `${TUH_TRANSFORM}/login` + document.location.search
    );
  };

  handleSelectDiagRule = (data: any) => {
    var obj = JSON.parse(data.content);
    this.setState({ targetForm: obj });
    this.setState({ targetDiagRule: data });
    this.props.history.push({
      pathname: `/form/${data.id}/`,
      state: {},
    });
  };

  handleGoBack = () => {
    console.log(
      " handleGoBack ",
      this.state.previousPathname,
      this.currentPathname.current
    );

    if (this.state.profileStepperIndex === 2 && this.state.openAllergyProfile) {
      this.setState({ openAllergyProfile: false });
      return;
    }
    // two case , 2 in stepper profilecreate
    if (
      (this.state.profileStepperIndex || 0) > 0 &&
      (this.state.profileStepperIndex || 0) <= 2
    ) {
      let next = (this.state.profileStepperIndex || 0) - 1;
      this.setState({ profileStepperIndex: next });
      return;
    }

    if (
      this.currentPathname.current.includes("/Chat/") &&
      this.state.previousPathname !== "/Chat"
    ) {
      this.props.history.push(`/Chat`);
    } else {
      this.props.history.goBack();
    }

    // this.setState({ backToApp: false });
    // if (!this.state.openChatBox) {
    //   this.props.history.push(`${TUH_TRANSFORM}/chat`);
    // } else {

    // }
    // else if (this.props.location.pathname.includes("profile")) {
    //   this.props.history.push(TUH_TRANSFORM);
    // } else if (this.props.location.pathname.includes("/payment/")) {
    //   this.props.history.push(TUH_TRANSFORM);
    // } else {
    //   this.props.history.goBack();
    // }
  };

  // Handle Menu Bar
  handleLogout = () => {
    console.log(" handleLogout");
    // Logout firebase
    if (this.controller.auth) { 
      signOut(this.controller.auth);
    }

    serviceWorker.unregister();
    if (window.FB) {
      window.FB.logout(function (response: any) {
        console.log(" user Logout Facebook !");
      });
    }
    console.log("unregister service worker");
    // Remove data
    Cookies.remove("fullname", { path: "/" });
    Cookies.remove("username", { path: "/" });
    Cookies.remove("apiToken", { path: "/" });
    Cookies.remove("division_id", { path: "/" });
    Cookies.remove("userId", { path: "/" });
    Cookies.remove("project_name", { path: "/" });
    Cookies.remove("firstPageAns", { path: "/" });
    let params = new URLSearchParams(this.props.location.search);

    console.log("handleLogout Cookies.apiToken: ", Cookies.apiToken);
    console.log("handleLogout Cookies.userId: ", Cookies.userId);
    console.log(
      "handleLogout this.props.location.pathname: ",
      this.props.location.pathname
    );
    console.log("handleLogout params: ", params);
    this.setState({
      apiToken: Cookies.apiToken,
      userId: Cookies.userId,
      login: false,
      profile: false,
      openLogoutMod: false,
    });
    
    if (config.LOGIN_WITH_TUH_TRANSFORM) {
      this.props.history.push({
        pathname: "/tuh-transform/login" + document.location.search,
        state: {},
      });
    } else {
      this.props.history.push({
        pathname: "/Login" + document.location.search,
        state: {},
      });
    }
  };

  handleAddHospitalProfile = () => {
    if (!this.chatBoxRef) {
      return;
    }
    let channelDetail = this.chatBoxRef.getChannelDetail();
    if (channelDetail && channelDetail.division) {
      this.setState(
        {
          chatDivision: channelDetail.division,
        },
        this.props.history.push({
          pathname: `/oa/${channelDetail.division}/`,
          state: {},
        })
      );
    }
  };

  handleOpenLogoutMod = () => {
    this.setState({ openSettingMod: false });
    this.setState({ openLogoutMod: !this.state.openLogoutMod });
  };

  // ProfileStepper
  handleChangeStep = (idx: number) => {
    this.setState({ profileStepperIndex: idx });
  };

  handleOpenAllergy = (isOpen: boolean) => {
    this.setState({ openAllergyProfile: isOpen });
  };

  handleOpenDeleteMod = () => {
    this.setState({ openSettingMod: false });
    this.setState({ openDeleteMod: !this.state.openDeleteMod });
  };

  handleSaveComplete = () => {
    this.props.history.push({
      pathname: `/Chat`,
      state: {},
    });
  };

  handleDeleteUser = async () => {
    console.log("this.state", this.state);

    let userId = this.state.userId as string;
    let apiToken = this.state.apiToken
      ? this.state.apiToken
      : Cookies.get("apiToken");
    console.log("apiToken: ", apiToken);

    console.log("userId", userId);
    // Clear Data
    const [data, error] = await this.props.profileController.postDeleteUser({
      apiToken,
      userId: userId ? parseInt(userId) : "",
    });

    if (window.FB) {
      window.FB.logout();
    }

    if (typeof window.iosNative !== "undefined") {
      window.iosNative.logout();
      return;
    }

    if (typeof window.MobNative !== "undefined") {
      window.MobNative.logout();
      return;
    }

    console.log("window.FB", window.FB);
    if (typeof window.FB !== "undefined") {
      console.log("Logout FB");
      window.FB.logout();
    }

    serviceWorker.unregister();
    console.log("unregister service worker");
    // Remove cookied
    Cookies.remove("apiToken", { path: "/" });
    Cookies.remove("project_name", { path: "/" });
    Cookies.remove("firstPageAns", { path: "/" });
    Cookies.remove("userId", { path: "/" });
    Cookies.remove("x-csrftoken");

    // Reset State
    this.setState({
      apiToken: undefined,
      userId: undefined,
      login: false,
      profile: false,
      openDeleteMod: false,
    });
    console.log(" remove all cookies", Cookies);
    if (config.LOGIN_WITH_TUH_TRANSFORM) {
      this.props.history.push({
        pathname: "/tuh-transform/login" + document.location.search,
        state: {},
      });
    } else {
      this.props.history.push({
        pathname: "/Login" + document.location.search,
        state: {},
      });
    }
  };

  handleSelectAddressBack = () => {
    if (this.selectAddressRef && this.selectAddressRef.goToDrugAddressConfirm) {
      this.selectAddressRef.goToDrugAddressConfirm();
    }
  };

  handleDrugAddressConfirmBack = () => {
    if (this.drugAddressConfirmRef && this.drugAddressConfirmRef.goBack) {
      this.drugAddressConfirmRef.goBack();
    }
  };

  handleOpenSettingMod = () => {
    this.setState({ openSettingMod: true });
  };

  handleCloseSettingMod = () => {
    this.setState({ openSettingMod: false });
  };

  handleGoToPayment = () => {
    this.props.history.push({ pathname: "/payment", state: {} });
  };

  handleUserProfile = () => {
    this.props.history.push({ pathname: "/profile", state: {} });
  };

  goToAppointment = () => {
    this.props.history.push("/Appointment");
  };

  gotoChatChannel = (chatChannelId: number) => {
    this.props.history.replace("/", { state: {} });
    if (chatChannelId) {
      let path = `/Chat/${chatChannelId}/`;
      this.handleChatChannelSelected(path);
    }
  };

  // for Chat --> dont want to fetch chat channel everytime
  loadChannelList = async () => {
    if (this.state.chatSearchValue) {
      return;
    }
    let apiToken = this.state.apiToken
      ? this.state.apiToken
      : Cookies.get("apiToken");
    let userId = this.state.userId
      ? this.state.userId
      : Cookies.get("userId");
    if (this.state.channelList?.length === 0) {
      this.setState({ chatLoading: true });
    }

    const [data, error] = await this.props.chatListController.getChatChanel(
      apiToken,
      userId
    );
    let sum_unread = 0;
    if (data) {
      if (
        data &&
        data.items &&
        Array.isArray(data.items) &&
        data.items.length > 0
      ) {
        console.log("data ", data);
        data.items.forEach((item: any) => {
          sum_unread += item.unread_message_count;
        });
      }
      this.showBadge(sum_unread);
      this.setState({ channelList: data.items, chatLoading: false });
    } else {
      this.showBadge(sum_unread);
      this.setState({ channelList: [], chatLoading: false });
    }
  };

  searchChannelList = async () => {
    let apiToken = this.state.apiToken
      ? this.state.apiToken
      : Cookies.get("apiToken");
    let userId = this.state.userId
      ? this.state.userId
      : Cookies.get("userId");
    // let search = inputRef.current.inputRef.current.value;
    let search = this.state.chatSearchValue;
    // if (this.state.channelList?.length === 0) {
    this.setState({ chatLoading: true });
    // }
    const [data, error] = await this.props.chatListController.searchChatChannel(
      apiToken,
      userId,
      search
    );
    this.setState({ chatLoading: false });
    if (data) {
      this.setState({ channelList: data.items });
    } else {
      this.setState({ channelList: [] });
    }
  };

  showBadge = (sum_unread: number) => {
    try {
      console.log("sum_unread = " + sum_unread);
      if (typeof window.iosNative !== "undefined") {
        window.iosNative.showBadge(sum_unread.toString());
      } else if (typeof window.MobNative !== "undefined") {
        window.MobNative.showBadge(sum_unread.toString());
      }
    } catch (e) {
      console.error("showBadge is not function...");
    }
  };

  getPropRoute = (pathRoute: string) => {
    const clearString = pathRoute.replace(/(\?|\/$)/gi, "");
    const regFormat = clearString.replace(
      /\/:\w+/g,
      (...res) => `(/(?<${res[0].slice(2)}>\\w+)|)`
    );
    const pathName = this.props.location.pathname;
    const exec = new RegExp(regFormat, "i").exec(pathName);
    const { groups } = exec || { groups: {} };
    const search = pathName.match(/\?.*/)?.[0];

    if (search) {
      this.props.location.search = search;
      this.props.history.location.search = search;
      this.props.location.pathname = pathName.replace(/\?.*/i, "");
      this.props.history.location.pathname = pathName.replace(/\?.*/i, "");
    }

    return {
      match: { params: groups },
      location: this.props.location,
      history: this.props.history,
    };
  };

  render = () => {
    console.log("MobTransform render:", this);

    return (
      <IntlProvider
        locale="th-TH"
        // messages={flattenMessages(messages["en-US"])}
        messages={flattenMessages(
          messages[this.state.language || LANGUAGE.EN_US]
        )}
      >
        <div style={{}} className="tf-transform">
          <ModConfirm
            open={this.state.openLogoutMod}
            // alertText="ต้องการออกจากระบบใช่หรือไม่"
            titleName={<FormattedMessage id="common.warning" />}
            alertText={<FormattedMessage id="auth.ask_logout" />}
            buttonLeft={<FormattedMessage id="common.cancel" />}
            buttonRight={<FormattedMessage id="common.confirm" />}
            onButtonLeftClick={this.handleOpenLogoutMod}
            onButtonRightClick={this.handleLogout}
          />

          <ModConfirm
            open={this.state.openDeleteMod}
            // alertText="ต้องการออกจากระบบใช่หรือไม่"
            titleName={<FormattedMessage id="common.warning" />}
            alertText={<FormattedMessage id="auth.ask_delete" />}
            buttonLeft={<FormattedMessage id="common.cancel" />}
            buttonRight={<FormattedMessage id="common.confirm" />}
            onButtonLeftClick={this.handleOpenDeleteMod}
            onButtonRightClick={this.handleDeleteUser}
          />

          <SlideRoutes duration={350} location={this.props.location}>
            <Route
              path="/tuh-transform/login"
              render={(props) => {
                return (
                  <>
                    <TFLogin
                      onEvent={this.controller.handleEvent}
                      history={this.props.history}
                      inputErrorLogin={this.state.inputErrorLogin}
                      loadingMainTransform={this.state.loadingMainTransform}
                      errorMessage={this.state.errorMessage}
                      successMessage={this.state.successMessage}
                    />
                  </>
                );
              }}
            />
            <Route
              path="/tuh-transform/register"
              render={(props) => {
                return (
                  <>
                    <TFRegister
                      onEvent={this.controller.handleEvent}
                      history={this.props.history}
                      viewIndexRegister={this.state.viewIndexRegister}
                      registerInfo={this.state.registerInfo}
                      firstRegistration={this.state.firstRegistration}
                      loadingMainTransform={this.state.loadingMainTransform}
                      errorMessage={this.state.errorMessage}
                      successMessage={this.state.successMessage}
                    />
                  </>
                );
              }}
            />
            <Route
              path="/tuh-transform/sign-in-email"
              render={(props) => {
                return (
                  <>
                    <TFSignInEmail
                      onEvent={this.controller.handleEvent}
                      history={this.props.history}
                      inputEmail={this.state.inputEmail}
                      inputEmailError={this.state.inputEmailError}
                      signInByEmailError={this.state.signInByEmailError}
                      registerInfo={this.state.registerInfo}
                      viewIndexRegister={this.state.viewIndexRegister}
                    />
                  </>
                );
              }}
            />
            <Route
              path="/tuh-transform/verify-identity"
              render={(props) => {
                return (
                  <>
                    <TFVerifyIdentity
                      onEvent={this.controller.handleEvent}
                      userProfile={this.state.userProfile}
                      userId={this.state.userProfile?.id || ""}
                      history={this.props.history}
                    />
                  </>
                );
              }}
            />
            <Route
              path="/tuh-transform/password"
              render={(props) => {
                return (
                  <>
                    <TFForgetPassword
                      onEvent={this.controller.handleEvent}
                      history={this.props.history}
                      inputEmailRequest={this.state.inputEmailRequest}
                      openModCheckEmail={this.state.openModCheckEmail}
                      registerInfo={this.state.registerInfo}
                      changePasswordData={this.state.changePasswordData}
                    />
                  </>
                );
              }}
            />
            <Route
              path="/tuh-transform/profile"
              render={() => {
                return (
                  <>
                    <div
                      className="tf-profile"
                      style={{
                        width: "100vw",
                        height: "calc(100vh - 50px)",
                        overflow: "auto",
                        paddingBottom: "20px",
                      }}
                    >
                      <TFHead
                        title={"Profile"}
                        // leftIconClick={this.handleGoBack}
                        hideLeftIcon
                      />
                      {CONFIG.ISHEALTH_PLATFORM_PROFILE ? (
                        <ProfileWrap
                          // isCompleteProfile={this.state.isCompleteProfile}
                          hideLogout={
                            this.state.projectName ===
                            PROJECT_NAME.M_B_PLUS_TELEMED
                          }
                          hideDeleteUser={true}
                          noApiToken={this.handleGoToLogin}
                          apiToken={this.state.apiToken}
                          controller={this.props.profileController}
                          onLogout={this.handleOpenLogoutMod}
                          handleGoBack={this.handleGoBack}
                          // saveComplete={()=>{this.setState({isCompleteProfile: true})}}
                          profileStepperIndex={this.state.profileStepperIndex}
                          onChangeProfileStepper={this.handleChangeStep}
                          openAllergyProfile={this.state.openAllergyProfile}
                          onSetOpenAllergy={this.handleOpenAllergy}
                          onDeleteUser={this.handleOpenDeleteMod}
                          saveComplete={this.handleSaveComplete}
                        />
                      ) : (
                        <Profile
                          hideLogout={
                            this.state.projectName ===
                            PROJECT_NAME.M_B_PLUS_TELEMED
                          }
                          hideDeleteUser={true}
                          noApiToken={this.handleGoToLogin}
                          apiToken={this.state.apiToken}
                          controller={this.props.profileController}
                          onLogout={this.handleOpenLogoutMod}
                          handleGoBack={this.handleGoBack}
                          onDeleteUser={this.handleOpenDeleteMod}
                        />
                      )}

                      <TFBottomNavigation
                        history={this.props.history}
                        activeItem="profile"
                      />
                    </div>
                  </>
                );
              }}
            ></Route>
            <Route
              exact
              path="/tuh-transform/Appointment/:appointId"
              render={(props) => {
                console.log(" Router  /Appointment/:appointId/ props: ", props);
                return (
                  <>
                    <TFHead leftIconClick={this.handleGoBack} />
                    <PatientSelectAppointment
                      {...this.getPropRoute(
                        "/tuh-transform/Appointment/:appointId"
                      )}
                      noApiToken={this.handleGoToLogin}
                      apiToken={this.state.apiToken}
                      controller={this.props.queueController}
                      languageUX={props.languageUX}
                    />
                  </>
                );
              }}
            />

            <Route
              path="/tuh-transform/Appointment"
              render={(props) => {
                console.log(" Router  /Appointment/ props: ", props);

                return (
                  <div>
                    <TimePatient
                      // {...props}
                      history={this.props.history}
                      location={this.props.location}
                      header={<TFHead title={"Appointment"} hideLeftIcon />}
                      noApiToken={this.handleGoToLogin}
                      apiToken={this.state.apiToken}
                      patientData={this.state.patientData}
                      controller={this.props.queueController}
                      handleGoBack={this.handleGoBack}
                      languageUX={this.props.languageUX}
                    />
                    <TFBottomNavigation
                      history={this.props.history}
                      activeItem="appointment"
                      languageUX={this.props.languageUX}
                    />
                  </div>
                );
              }}
            />

            <Route
              exact
              path="/tuh-transform/drug-address-confirm/:encounterId/"
              render={(props) => {
                return (
                  <DrugAddressConfirm
                    {...this.getPropRoute(
                      "/tuh-transform/drug-address-confirm/:encounterId/"
                    )}
                    ref={(ref: any) => (this.drugAddressConfirmRef = ref)}
                    menuBar={
                      <TFHead
                        leftLabel={
                          <FormattedMessage id="drug_delivery.confirm_drug_address" />
                        }
                        leftIconClick={this.handleDrugAddressConfirmBack}
                      />
                    }
                    apiToken={this.state.apiToken}
                    patientData={this.state.patientData}
                    controller={this.props.addressController}
                    noApiToken={this.getApiToken}
                    onCancel={this.handleDrugAddressConfirmBack}
                  />
                );
              }}
            />
            <Route
              exact
              path="/tuh-transform/select-address/:encounterId?/"
              render={(props) => {
                return (
                  <SelectAddress
                    {...this.getPropRoute(
                      "/tuh-transform/select-address/:encounterId?/"
                    )}
                    ref={(ref: any) => (this.selectAddressRef = ref)}
                    menuBar={
                      <TFHead
                        leftLabel={
                          <FormattedMessage id="drug_delivery.select_address" />
                        }
                        leftIconClick={this.handleSelectAddressBack}
                      />
                    }
                    apiToken={this.state.apiToken}
                    patientData={this.state.patientData}
                    controller={this.props.addressController}
                    noApiToken={this.getApiToken}
                  />
                );
              }}
            />
            <Route
              exact
              path="/tuh-transform/edit-address/:addressId/"
              render={(props) => {
                return (
                  <EditAddress
                    {...this.getPropRoute(
                      "/tuh-transform/edit-address/:addressId/"
                    )}
                    menuBar={
                      <TFHead
                        leftLabel={
                          <FormattedMessage id="drug_delivery.edit_address" />
                        }
                        leftIconClick={this.handleGoBack}
                      />
                    }
                    apiToken={this.state.apiToken}
                    patientData={this.state.patientData}
                    controller={this.props.addressController}
                    noApiToken={this.getApiToken}
                  />
                );
              }}
            />
            <Route
              exact
              path="/tuh-transform/edit-address/"
              render={(props) => (
                <EditAddress
                  // {...props}
                  match={{ params: {} }}
                  history={this.props.history}
                  location={this.props.location}
                  menuBar={
                    <TFHead
                      leftLabel={
                        <FormattedMessage id="drug_delivery.add_edit_address" />
                      }
                      leftIconClick={this.handleGoBack}
                    />
                  }
                  apiToken={this.state.apiToken}
                  patientData={this.state.patientData}
                  controller={this.props.addressController}
                  noApiToken={this.getApiToken}
                />
              )}
            />

            <Route
              exact
              path="/tuh-transform/form/:id/"
              render={(props) => {
                return (
                  <div className="App-main">
                    <div className="App-content">
                      <TFHead leftIconClick={this.handleGoBack} />
                      <DiagForm
                        {...this.getPropRoute("/tuh-transform/form/:id/")}
                        noApiToken={this.handleGoToLogin}
                        apiToken={this.state.apiToken}
                        controller={this.props.diagFormController}
                        diagRule={this.state.targetDiagRule}
                        onFinished={this.gotoChatChannel}
                      />
                    </div>
                  </div>
                );
              }}
            />

            <Route
              path="/tuh-transform/diagrulesearch"
              render={() => {
                return (
                  <div>
                    <TFHead leftIconClick={this.handleGoBack} />
                    <DiagRuleSearch
                      noApiToken={this.handleGoToLogin}
                      apiToken={this.state.apiToken}
                      controller={this.props.diagRuleController}
                      onSeleted={this.handleSelectDiagRule}
                      handleGoBack={this.handleGoBack}
                    />
                  </div>
                );
              }}
            />

            <Route
              exact
              path="/tuh-transform/OA/:id"
              render={(props) => {
                return (
                  <div>
                    <TFHead leftIconClick={this.handleGoBack} />
                    <OfficialAccount
                      {...this.getPropRoute("/tuh-transform/OA/:id")}
                      apiToken={this.state.apiToken}
                      division={this.state.chatDivision}
                      controller={this.props.officialAccountController}
                      handleGoBack={this.handleGoBack}
                      onSetBackToApp={(value: boolean) => {
                        this.setState({ backToApp: value });
                      }}
                    />
                  </div>
                );
              }}
            ></Route>

            <Route
              path="/tuh-transform/Chat/:chatChannelId/"
              render={(props) => {
                return (
                  <div className="chat-box-wrapper tf-chat-box">
                    <TFHead
                      rightIcon="file alternate"
                      leftLabel={
                        this.state.chatName && this.state.chatName.length < 20
                          ? this.state.chatName
                          : this.state.chatName
                          ? this.state.chatName
                          : "Unknown"
                      }
                      leftIconClick={this.handleGoBack}
                      rightIconClick={this.handleAddHospitalProfile}
                    />
                    <ChatBox
                      {...this.getPropRoute(
                        "/tuh-transform/Chat/:chatChannelId/"
                      )}
                      division={this.state.chatDivision}
                      ref={(ref) => (this.chatBoxRef = ref)}
                      noApiToken={this.getApiToken}
                      apiToken={this.state.apiToken}
                      userId={this.state.userId}
                      patientData={this.state.patientData}
                      controller={this.props.chatController}
                      useNormalTextAreaKey={true}
                      onSetChannelName={this.handleSetChatName}
                      onNavigationMessage={this.handleNavigationMessage}
                      onSetBackToApp={(value: boolean) => {
                        this.setState({ backToApp: value });
                      }}
                      disabledScrollIntoView={this.state.disabledScrollIntoView}
                    />
                  </div>
                );
              }}
            />

            <Route
              exact
              path="/tuh-transform/payment/:divisionId?/"
              render={(props) => {
                return (
                  <div>
                    <PatientPayment
                      {...this.getPropRoute(
                        "/tuh-transform/payment/:divisionId?/"
                      )}
                      apiToken={this.state.apiToken}
                      controller={this.props.paymentController}
                      patientData={this.state.patientData}
                      onSetBackToApp={(value: boolean) => {
                        this.setState({ backToApp: value });
                      }}
                      // onNoPatientId={this.getPatientDetail}
                      noApiToken={this.getApiToken}
                      menuBar={
                        <TFHead
                          title={"Payment"}
                          leftIconClick={this.handleGoBack}
                        />
                      }
                      languageUX={this.state.userSelectedLanguage}
                    />
                    {/* <TFBottomNavigation
                      history={this.props.history}
                      activeItem="payment"
                    /> */}
                  </div>
                );
              }}
            />
            <Route
              exact
              path="/tuh-transform/paymentDetail/:id/"
              render={(props) => {
                return (
                  <PatientPaymentDetail
                    {...this.getPropRoute("/tuh-transform/paymentDetail/:id/")}
                    apiToken={this.state.apiToken}
                    controller={this.props.paymentController}
                    patientData={this.state.patientData}
                    menuBar={<TFHead leftIconClick={this.handleGoBack} />}
                    languageUX={this.state.userSelectedLanguage}
                  />
                );
              }}
            />
            <Route
              path="/tuh-transform/other"
              render={(props) => {
                return (
                  <div>
                    Other
                    <TFBottomNavigation
                      history={this.props.history}
                      activeItem="other"
                    />
                  </div>
                );
              }}
            />

            <Route
              path="/tuh-transform/"
              render={(props) => {
                return (
                  <div className="tf-transform-chat">
                    <TFHead
                      title={"Chat"}
                      leftIcon={
                        <SettingPopup
                          onOpen={this.handleOpenSettingMod}
                          onClose={this.handleCloseSettingMod}
                          open={this.state.openSettingMod}
                          handleUserProfile={this.handleUserProfile}
                          handleGoToPayment={this.handleGoToPayment}
                          goToAppointment={this.goToAppointment}
                          goToVaccineAppointment={() => {}}
                          goToVaccineAppointmentView={() => {}}
                          handleLogout={this.handleOpenLogoutMod}
                        />
                      }
                      rightIcon="hospital"
                      rightIconClick={this.handleAddDiagRule}
                    />
                    <TFChatList
                      ref={(ref: any) => (this.chatListRef = ref?.chatListRef)}
                      apiToken={this.state.apiToken}
                      userId={this.state.userId}
                      chatListController={this.props.chatListController}
                      noApiToken={this.getApiToken}
                      // noApiToken={this.handleGoToLogin}
                      isLoading={this.state.chatLoading}
                      onChannelSelected={this.handleChatChannelSelected}
                      onRedirectedChannelSelected={
                        this.handleRedirectChatChannelSelected
                      }
                      loadChannelList={this.loadChannelList}
                      channelList={this.state.channelList}
                      onSearchChange={this.handleChatSearchChange}
                      searchChannelList={this.searchChannelList}
                      chatSearchValue={this.state.chatSearchValue}
                      onUnfollowChannelSelected={
                        this.handleUnfollowChannelSelected
                      }
                    />
                    <TFBottomNavigation
                      history={this.props.history}
                      activeItem="chat"
                    />
                  </div>
                );
              }}
            />
          </SlideRoutes>
        </div>
      </IntlProvider>
    );
  };
}

export default withRouter(MobTransform);
